import { useEffect, useState } from 'react';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { FaWeight } from 'react-icons/fa'
import { FiUpload } from 'react-icons/fi';
import { useMyContext } from '../../../../context/MyContext';
import StatusRaised from '../../../../component/b2c/models/statusRaised';
import '../../../../css/custom-scrollbar.css'
import { toast } from 'react-toastify';
import axios from 'axios';
import { Base_Url, dispute_action, weightListByStatus, weightListStatusBylosed, weightListStatusByAccept, weightDisputesAllforUser } from '../../../../config/config'


const WeightDisputeDashboard = () => {
  const [activeTab, setActiveTab] = useState('action');
  const [selectAll, setSelectAll] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const { isDarkMode, isToggleSidebar,setIsToggleSidebar } = useMyContext();
  const [actionRequiredData, setActionrequiredData] = useState([]);
  const [acceptData, setAcceptData] = useState([]);
  const [closedData, setClosedData] = useState([]);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCustomer, setTotalCustomers] = useState(0)
  const [selectedWaybillNo, setSelectedWaybillNo] = useState()
  const [allWeightDisputess, setAllWeightDisputes] = useState([]);
  const [allSellerId, setAllSelerId] = useState();

  const handleViewClick = (waybill) => {
    setSelectedWaybillNo(waybill)
    setIsPopupOpen(true);
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    if (activeTab === 'accepted') {
      getAcceptData();
    } else if (activeTab === 'action') {
      getWeightDisputesData();
    }
    else if (activeTab === 'disputes') {
      allWeightDisputes();
    }
    else if (activeTab === 'closed') {
      getClosedData();
    }
  }, [activeTab, limit, currentPage]);

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePaginationChange = (e, value) => {
    setCurrentPage(value);
  };

  const tabs = [
    { id: 'action', label: 'Action Required' },
    { id: 'closed', label: 'Closed' },
    { id: 'accepted', label: 'Accepted' },
    { id: 'disputes', label: 'All Disputes' },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setTotalCustomers(0);
  }

  const getWeightDisputesData = async () => {
    const url = `${Base_Url}${weightListByStatus}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setActionrequiredData(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const getClosedData = async () => {
    const url = `${Base_Url}${weightListStatusBylosed}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setClosedData(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const getAcceptData = async () => {
    const url = `${Base_Url}${weightListStatusByAccept}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setAcceptData(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const allWeightDisputes = async () => {
    const url = `${Base_Url}${weightDisputesAllforUser}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setAllWeightDisputes(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleAccept = async (row) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');

    const formData = new FormData();
    formData.append("waybill", row.waybill);
    formData.append("status", "Accept");
    formData.append("amount", row.price);
    formData.append("seller_id", row.seller_id);

    try {
      const response = await axios.post(Base_Url + dispute_action, formData, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error uploading data: " + error.message);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows([...Array(actionRequiredData.length).keys()]);
      setAllSelerId([...Array(actionRequiredData.seler_id)]);
    } else {
      setSelectedRows([]);
      setAllSelerId('');
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      if (isSelected) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };
  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

      <NavBar />
      <div className="flex flex-1 overflow-hidden">
         {isToggleSidebar && (
                          <div
                            className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                            onClick={() => setIsToggleSidebar(false)}
                          />
                        )}
              
                        <div
                          className={`
                            fixed inset-y-0 left-0 z-50 w-64
                            ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                            md:static md:inset-auto md:z-auto md:translate-x-0
                            ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                            m-3
                            rounded-3xl
                        
                            overflow-hidden
                            transition-all
                            duration-300
                            ease-in-out
                          `}
                        >
                          <Sidebar />
                        </div>

        <div className="flex-1 dark:bg-black p-3 md:p-4 w-full bg-gray-200 overflow-hidden flex flex-col">

          {/* Header */}
          <div className="flex-shrink-0 flex items-center gap-3 mb-3">
            <div className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
              <FaWeight className="w-4 h-4 text-gray-600 dark:text-gray-400" />
            </div>
            <div>
              <h1 className="text-sm font-bold text-gray-800 dark:text-white tracking-tight">Weight Disputes</h1>
              <p className="text-[9px] text-gray-400 dark:text-gray-500">Manage and resolve weight dispute claims</p>
            </div>
            <span className="ml-auto text-[9px] font-medium text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-700 px-2.5 py-0.5 rounded-full">
              {totalCustomer} total
            </span>
          </div>

          {/* Tabs */}
          <div className="flex-shrink-0  dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-1 flex gap-1 mb-3 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`flex items-center justify-center px-3 py-1.5 rounded-md text-[9px] font-medium whitespace-nowrap transition-all duration-200 flex-1 ${activeTab === tab.id
                    ? 'bg-gray-800 dark:bg-white text-white dark:text-gray-800 shadow-sm'
                    : 'text-gray-500 bg-white dark:text-gray-400 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800'
                  }`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Bulk Actions */}
          {selectAll && (
            <div className="flex-shrink-0 grid grid-cols-2 gap-2 mb-3">
              <button className="px-3 py-1.5 text-[9px] font-medium rounded-lg bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80 transition-all">
                Accept Bulk
              </button>
              <button className="px-3 py-1.5 text-[9px] font-medium rounded-lg border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all">
                Raise Bulk
              </button>
            </div>
          )}

          {/* Table */}
          <div className="flex-1 overflow-y-auto overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 custom-scrollbar">
            {activeTab === 'action' && (
              <table className="min-w-full table-auto">
                <thead className="bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[9px] uppercase tracking-wider sticky top-0 z-10">
                  <tr>
                    <th className='px-2 py-1.5 text-center w-8'>
                      <input type="checkbox" checked={selectAll} onChange={handleSelectAll} className="accent-gray-800 dark:accent-white" />
                    </th>
                    <th className='px-2 py-1.5 text-left font-semibold'>AWB No</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Init. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Dimension</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Product</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>SKU</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Status</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Rev. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Price</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                  {actionRequiredData.map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors bg-white dark:bg-gray-900">
                      <td className='px-2 py-1.5 text-center'>
                        <input type="checkbox" checked={selectedRows.includes(index)} onChange={() => handleRowSelect(index)} className="accent-gray-800 dark:accent-white" />
                      </td>
                      <td className="px-2 py-1.5 text-[10px] font-mono text-gray-700 dark:text-gray-300">{row.waybill}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.initial_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.dimension}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 max-w-[100px] truncate">{row.product_des}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.sku}</td>
                      <td className="px-2 py-1.5">
                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[8px] font-medium bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600">
                          {row.status}
                        </span>
                      </td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">{row.reversed_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">₹{row.price}</td>
                      <td className="px-2 py-1.5">
                        <div className="flex items-center gap-1">
                          <button
                            className="px-2 py-0.5 text-[8px] font-medium rounded bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80 transition-all"
                            onClick={() => handleAccept(row)}
                          >
                            Accept
                          </button>
                          <button
                            className="px-2 py-0.5 text-[8px] font-medium rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all"
                            onClick={() => handleViewClick(row.waybill)}
                          >
                            Raise
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {actionRequiredData.length === 0 && (
                    <tr>
                      <td colSpan="10" className="p-6 text-center text-[10px] text-gray-400 dark:text-gray-500">No action required</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {activeTab === 'accepted' && (
              <table className="min-w-full table-auto">
                <thead className="bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[9px] uppercase tracking-wider sticky top-0 z-10">
                  <tr>
                    <th className='px-2 py-1.5 text-left font-semibold'>AWB No</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Init. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Dimension</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Product</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>SKU</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Rev. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Price</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                  {acceptData.map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors bg-white dark:bg-gray-900">
                      <td className="px-2 py-1.5 text-[10px] font-mono text-gray-700 dark:text-gray-300">{row.waybill}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.initial_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.dimension}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 max-w-[100px] truncate">{row.product_des}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.sku}</td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">{row.reversed_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">₹{row.price}</td>
                    </tr>
                  ))}
                  {acceptData.length === 0 && (
                    <tr>
                      <td colSpan="7" className="p-6 text-center text-[10px] text-gray-400 dark:text-gray-500">No accepted disputes</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {activeTab === 'disputes' && (
              <table className="min-w-full table-auto">
                <thead className="bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[9px] uppercase tracking-wider sticky top-0 z-10">
                  <tr>
                    <th className='px-2 py-1.5 text-left font-semibold'>AWB No</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Init. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Dimension</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Product</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>SKU</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Status</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Rev. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Price</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                  {allWeightDisputess.map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors bg-white dark:bg-gray-900">
                      <td className="px-2 py-1.5 text-[10px] font-mono text-gray-700 dark:text-gray-300">{row.waybill}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.initial_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.dimension}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 max-w-[100px] truncate">{row.product_des}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.sku}</td>
                      <td className="px-2 py-1.5">
                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[8px] font-medium bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600">
                          {row.status}
                        </span>
                      </td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">{row.reversed_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">₹{row.price}</td>
                    </tr>
                  ))}
                  {allWeightDisputess.length === 0 && (
                    <tr>
                      <td colSpan="8" className="p-6 text-center text-[10px] text-gray-400 dark:text-gray-500">No disputes found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {activeTab === 'closed' && (
              <table className="min-w-full table-auto">
                <thead className="bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[9px] uppercase tracking-wider sticky top-0 z-10">
                  <tr>
                    <th className='px-2 py-1.5 text-left font-semibold'>AWB No</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Init. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Dimension</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Product</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>SKU</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Status</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Rev. Wt</th>
                    <th className='px-2 py-1.5 text-left font-semibold'>Price</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                  {closedData.map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors bg-white dark:bg-gray-900">
                      <td className="px-2 py-1.5 text-[10px] font-mono text-gray-700 dark:text-gray-300">{row.waybill}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.initial_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.dimension}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 max-w-[100px] truncate">{row.product_des}</td>
                      <td className="px-2 py-1.5 text-[10px] text-gray-700 dark:text-gray-300">{row.sku}</td>
                      <td className="px-2 py-1.5">
                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[8px] font-medium bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600">
                          {row.status}
                        </span>
                      </td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">{row.reversed_weight}</td>
                      <td className="px-2 py-1.5 text-[10px] font-semibold text-gray-800 dark:text-white">₹{row.price}</td>
                    </tr>
                  ))}
                  {closedData.length === 0 && (
                    <tr>
                      <td colSpan="8" className="p-6 text-center text-[10px] text-gray-400 dark:text-gray-500">No closed disputes</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Pagination */}
          <div className="flex-shrink-0 mt-3 pt-2 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-center gap-2">
            <span className="text-[9px] text-gray-500 dark:text-gray-400 font-medium">
              Total: <span className="text-gray-800 dark:text-white font-semibold">{totalCustomer}</span>
            </span>
            <div className="flex items-center gap-2">
              <select
                id="limit"
                value={limit}
                onChange={handleLimitChange}
                className="border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-0.5 text-[9px] bg-white dark:bg-black text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-400"
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={totalCustomer}>All</option>
              </select>
              <Pagination
                count={Math.ceil(totalCustomer / limit)}
                page={currentPage}
                onChange={handlePaginationChange}
                variant="outlined"
                shape="rounded"
                size="small"
                sx={{
                  '& .MuiPaginationItem-root': {
                    fontSize: '9px',
                    borderColor: isDarkMode ? '#374151' : '#d1d5db',
                    color: isDarkMode ? '#fff' : '#000',
                    '&.Mui-selected': {
                      backgroundColor: isDarkMode ? '#fff' : '#000',
                      color: isDarkMode ? '#000' : '#fff',
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <StatusRaised isopen={isPopupOpen} onClose={handleClose} waybill_no={selectedWaybillNo} />
    </div>
  );
};

export default WeightDisputeDashboard;